import 'react';
import classnames from 'classnames';
import { Section } from '@mshops-components-library/common';
import { Button } from '@andes/button';
import { Typography } from '@andes-landings/typography';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var getTitleClassName = function getTitleClassName(title) {
  var titleClassName = classnames('section-text__title', (title === null || title === void 0 ? void 0 : title.align) && "section-text__title--".concat(title === null || title === void 0 ? void 0 : title.align));
  return titleClassName;
};
var getSubTitleClassName = function getSubTitleClassName(steeringWheel) {
  var subTitleClassName = classnames('section-text__subtitle', _defineProperty({}, "section-text__subtitle--".concat(steeringWheel === null || steeringWheel === void 0 ? void 0 : steeringWheel.align), steeringWheel === null || steeringWheel === void 0 ? void 0 : steeringWheel.align));
  return subTitleClassName;
};
var getTextClassName = function getTextClassName(text) {
  var textClassName = classnames('section-text__text', (text === null || text === void 0 ? void 0 : text.align) && "section-text__text--".concat(text === null || text === void 0 ? void 0 : text.align));
  return textClassName;
};
var getCtasClassName = function getCtasClassName(ctas) {
  var ctasClassName = classnames('section-text__row-buttons-actions', (ctas === null || ctas === void 0 ? void 0 : ctas.align) && "section-text__row-buttons-actions--".concat(ctas === null || ctas === void 0 ? void 0 : ctas.align));
  return ctasClassName;
};
var getActionsClassName = function getActionsClassName() {
  var actionsClassName = classnames('section-text__row-buttons-actions__btn-action-user', 'section-text__row-buttons-actions__btn-action-user--default');
  return actionsClassName;
};
var getActionsSecondaryClassName = function getActionsSecondaryClassName() {
  var actionsSecondaryClassName = classnames('section-text__row-buttons-actions__btn-action-user', 'section-text__row-buttons-actions__btn-action-user--quiet');
  return actionsSecondaryClassName;
};
var getSectionTextClassNames = function getSectionTextClassNames(_ref) {
  var title = _ref.title,
    steeringWheel = _ref.steeringWheel,
    text = _ref.text,
    ctas = _ref.ctas;
  return {
    titleClassName: getTitleClassName(title),
    subTitleClassName: getSubTitleClassName(steeringWheel),
    textClassName: getTextClassName(text),
    ctasClassName: getCtasClassName(ctas),
    actionsClassName: getActionsClassName(),
    actionsSecondaryClassName: getActionsSecondaryClassName()
  };
};
var getSectionTextClassNames$1 = getSectionTextClassNames;
var handleCtaClick = function handleCtaClick(_ref) {
  var href = _ref.href,
    event = _ref.event;
  if (!href) {
    event.preventDefault();
  }
};
var handleCtaClick$1 = handleCtaClick;
var SectionTextGeneral = function SectionTextGeneral(_ref) {
  var _ctas$buttons;
  var title = _ref.title,
    text = _ref.text,
    ctas = _ref.ctas,
    steeringWheel = _ref.steering_wheel,
    classNames = _ref.classNames,
    _ref$isEshops = _ref.isEshops,
    isEshops = _ref$isEshops === void 0 ? true : _ref$isEshops,
    deviceType = _ref.deviceType,
    storeType = _ref.storeType;
  var ctasClassName = classNames.ctasClassName;
  var isMobile = deviceType === 'mobile';
  var isAvailableStoreType = storeType === 'seller' || storeType === 'brand' || storeType === 'affiliate';
  var sectionTextContainerClass = classnames('section-text', {
    'section-text--old-styles': !isAvailableStoreType
  });
  var sectionTextRowSubtitleClass = classnames('section-text__row section-text__row--fill', 'section-text__row--subtitle');
  var sectionTextRowTitleClass = classnames('section-text__row section-text__row--fill', 'section-text__row--title');
  var sectionTextRowParagraphClass = classnames('section-text__row section-text__row--fill', 'section-text__row--paragraph');
  var alignTypographyClassName = (text === null || text === void 0 ? void 0 : text.align) && "section-text__typography section-text__typography--".concat(text === null || text === void 0 ? void 0 : text.align);
  var positionClassName = "section-text__container section-text__container--".concat(text === null || text === void 0 ? void 0 : text.align);
  var sectionTextButtonsClass = classnames(ctasClassName, {
    'section-text__row-buttons-actions--wrap': !isEshops && isMobile
  });
  var sizeTitleTypography = isMobile ? 's' : 'xl';
  return /*#__PURE__*/_createRawReactElement(Section, {
    className: sectionTextContainerClass
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: positionClassName
  }, void 0, (steeringWheel === null || steeringWheel === void 0 ? void 0 : steeringWheel.text) && !(steeringWheel !== null && steeringWheel !== void 0 && steeringWheel.hidden) && /*#__PURE__*/_createRawReactElement(Typography, {
    className: "".concat(sectionTextRowSubtitleClass, " ").concat(alignTypographyClassName),
    type: "title",
    weight: "regular",
    size: "s"
  }, void 0, steeringWheel.text), (title === null || title === void 0 ? void 0 : title.text) && !(title !== null && title !== void 0 && title.hidden) && /*#__PURE__*/_createRawReactElement(Typography, {
    component: "h3",
    className: "".concat(sectionTextRowTitleClass, " ").concat(alignTypographyClassName),
    type: "title",
    size: sizeTitleTypography
  }, void 0, title.text), (text === null || text === void 0 ? void 0 : text.text) && !(text !== null && text !== void 0 && text.hidden) && /*#__PURE__*/_createRawReactElement(Typography, {
    className: "".concat(sectionTextRowParagraphClass, " ").concat(alignTypographyClassName),
    type: "body",
    weight: "regular",
    size: "m",
    color: "primary"
  }, void 0, text.text), (ctas === null || ctas === void 0 || (_ctas$buttons = ctas.buttons) === null || _ctas$buttons === void 0 ? void 0 : _ctas$buttons.length) > 0 && /*#__PURE__*/_createRawReactElement("div", {
    className: sectionTextButtonsClass
  }, void 0, ctas.buttons.map(function (row, index) {
    return row.message && !row.hidden && /*#__PURE__*/_createRawReactElement(Button, {
      hierarchy: "loud",
      size: "medium",
      href: row.href,
      onClick: function onClick(event) {
        return handleCtaClick$1({
          href: row.href,
          event: event
        });
      }
    }, "".concat(index + 0, "-").concat(row.message), row.message);
  }))));
};
var SectionTextView = SectionTextGeneral;
var SectionText = function SectionText(_ref) {
  var _ctas$buttons;
  var title = _ref.title,
    text = _ref.text,
    ctas = _ref.ctas,
    steeringWheel = _ref.steering_wheel,
    isEshops = _ref.isEshops,
    deviceType = _ref.deviceType,
    isCustomHtml = _ref.isCustomHtml,
    storeType = _ref.storeType;
  if (title !== null && title !== void 0 && title.hidden && steeringWheel !== null && steeringWheel !== void 0 && steeringWheel.hidden && text !== null && text !== void 0 && text.hidden && ctas !== null && ctas !== void 0 && ctas.hidden) {
    return null;
  }
  if (!(title !== null && title !== void 0 && title.text) && !(steeringWheel !== null && steeringWheel !== void 0 && steeringWheel.text) && !(text !== null && text !== void 0 && text.text) && !(ctas !== null && ctas !== void 0 && (_ctas$buttons = ctas.buttons) !== null && _ctas$buttons !== void 0 && _ctas$buttons.length) > 0) {
    return null;
  }
  var classNames = getSectionTextClassNames$1({
    title: title,
    steeringWheel: steeringWheel,
    text: text,
    ctas: ctas
  });
  return /*#__PURE__*/_createRawReactElement(SectionTextView, {
    text: text,
    ctas: ctas,
    title: title,
    classNames: classNames,
    steering_wheel: steeringWheel,
    isEshops: isEshops,
    deviceType: deviceType,
    isCustomHtml: isCustomHtml,
    storeType: storeType
  });
};
var SectionText$1 = SectionText;
export { SectionText$1 as SectionText, SectionText$1 as default };
